<template>
    <div>
        <div
            class="select"
            :class="{ 'is-danger' : errors.has(formName) }"
        >
            <select
                v-model="localValue.value"
                :name="formName"
                v-validate="'required'"
            >
                <option
                    v-for="v in options"
                    :key="v.value"
                    :value="v.value"
                >
                    {{v.label}}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name : "FieldOptions",
    inject : ['$validator'],
    props : {
        value : {
        },
        options : {
            type : Array,
            required : true,
        },
        formName : {
            type : String,
            required : true,
        },
    },
    computed : {
        localValue : {
            get () { return this.value },
            set () { this.$emit('input', this.localValue )}
        }
    },
}
</script>

<style scoped>
</style>
